import React, { useRef, useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Slider from "react-slick";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSection from "../../molecules/title-section";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";

// Styles //
import "./our-services.scss";

const OurServices = (props: ReferenciaContenido) => {
    const {tituloGeneral, referenciaPlantillaContenido} = props;
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef<Slider | null>(null);

    const handlePrevClick = () => {
        const newSlide = Math.max(currentSlide - 3, 0);
        setCurrentSlide(newSlide);
        sliderRef.current?.slickGoTo(newSlide);
    };

    const handleNextClick = () => {
        const newSlide = Math.min(currentSlide + 3, referenciaPlantillaContenido.length - 3);
        setCurrentSlide(newSlide);
        sliderRef.current?.slickGoTo(newSlide);
    };

    const CarouselServices = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        beforeChange: (_: number, nextSlide: number) => setCurrentSlide(nextSlide),
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.35,
                    dots:false,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className="o-our-services">
            <div className="o-our-services__header">
                <div className={`o-our-services__header__title`}>
                    <TitleSection title={tituloGeneral}/>
                </div>
                {window.innerWidth > 768 && referenciaPlantillaContenido.length > 3 &&
                    <div className="o-our-services__header__arrows">
                        <PreviousArrowButton canGoPrev={currentSlide > 0} onClick={handlePrevClick}/>
                        <NextArrowButton canGoNext={currentSlide < referenciaPlantillaContenido.length - 3} onClick={handleNextClick}/>
                    </div>
                }
            </div>
            <div className={`o-our-services__carousel-slider`}>
                <Slider ref={sliderRef} {...CarouselServices}> 
                    {referenciaPlantillaContenido.map((card, index) => {
                        return(
                            <div className={`o-our-services__carousel-card`} key={index}>
                                <figure className={`o-our-services__carousel-figure`}>
                                    <img src={card.imagenPrincipal[0]?.file.url} />
                                </figure>
                                <div className={`o-our-services__carousel-text`}>
                                    <h4 className={`o-our-services__carousel-title`}>{card.tituloBanner}</h4>
                                    {card.descripcion && documentToReactComponents(card.descripcion?.json)}
                                    {card.tituloBoton && card.redireccionBoton &&
                                        <a 
                                            className={`o-our-services__carousel-link gtmPersonasClickButton-${card.imagenPrincipal[0]?.description}`}
                                            href={card.redireccionBoton} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            {card.tituloBoton}
                                        </a>
                                    }
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
};

export default OurServices;
